var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5439 3.4375C21.0682 3.4375 21.4932 3.86253 21.4932 4.38682V15.7787C21.4932 16.303 21.0682 16.728 20.5439 16.728H3.45607C2.93177 16.728 2.50674 16.303 2.50674 15.7787V4.38682C2.50674 3.86253 2.93177 3.4375 3.45607 3.4375H20.5439ZM21.0186 19.1014C21.2807 19.1014 21.4932 19.3139 21.4932 19.576V20.5253C21.4932 20.7875 21.2807 21 21.0186 21H2.98141C2.71926 21 2.50674 20.7875 2.50674 20.5253V19.576C2.50674 19.3139 2.71926 19.1014 2.98141 19.1014H21.0186ZM11.0216 13.0076C11.0216 13.2697 11.2341 13.4822 11.4962 13.4822H12.4931C12.7553 13.4822 12.9678 13.2697 12.9678 13.0076V10.2327H14.7567C14.8797 10.2327 14.998 10.1849 15.0865 10.0994C15.275 9.91724 15.2802 9.61675 15.098 9.42821L12.3241 6.55687C12.2903 6.51163 12.2482 6.47255 12.1998 6.44149C11.9771 6.29859 11.6746 6.35436 11.5243 6.56606L8.87128 9.43578C8.7902 9.52349 8.74516 9.63855 8.74516 9.758C8.74516 10.0202 8.95767 10.2327 9.21982 10.2327H11.0216V13.0076Z",
    fill: "#23C343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOff);
export default __webpack_public_path__ + "static/media/ShareOff.c775bf18216ee1d4874296588a90d13b.svg";
export { ForwardRef as ReactComponent };